import React, { useEffect, useRef, useState } from 'react';
import { Table } from '../../components/Table/Table';
import { delete_icon, edit_icon, no_image, search_icon } from '../../assets/imgs';
import { admin_list, Transaction_list } from '../redux/api/dummyJson';
import { useLazyPropertiesListDropQuery, useLazyTotalLocationsListQuery, useSubscriptionListMutation } from '../redux/api/api';
import moment from 'moment';
import CustomSearchSelect from '../../components/Searchbox/CustomSearch';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';

const TransactionList = () => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [cities, setCities] = useState([])
    const [list, setList] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [fromdate, setFromDate] = useState(moment(new Date()).format('YYYY-MM-DD'))
    const [toDate, setToDate] = useState(moment(new Date()).format('YYYY-MM-DD'))
    const [city, setCity] = useState('')
    const [search, setSearch] = useState('')
    const [selectedCityId, setSelectedCityId] = useState('')
    const [properties, setProperties] = useState([])
    const [selectedPropertyId, setSelectedPropertyId] = useState('')


    const [transactionListApi] = useSubscriptionListMutation();
    const [getCityApi] = useLazyTotalLocationsListQuery()
    const [getPropertyApi] = useLazyPropertiesListDropQuery()

    const transactionList = (pageno, fromdate, toDate, selectedPropertyId, search) => {
        const formdata = new FormData();
        formdata.append("page", pageno)
        formdata.append("per_page", 10)
        if (fromdate && toDate) {
            formdata.append('from_date', moment(fromdate).format('YYYY-MM-DD'))
            formdata.append('to_date', moment(toDate).format('YYYY-MM-DD'))
        }
        if (selectedPropertyId) {
            formdata.append("property_name", selectedPropertyId)
        }
        // if (selectedCityId) {
        //     formdata.append("city_id", selectedCityId)
        // }
        if (search) {
            formdata.append('search', search)
        }
        formdata.append("row", 10)
        setFromDate(fromdate)
        setToDate(toDate)
        // setCity(city)
        setProperties(properties)
        setSearch(search)
        transactionListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let temp = []
                res?.data?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setPagecount(res?.pagination)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }


    const getLocations = () => {
        getCityApi()
            .unwrap()
            .then((res) => {
                console.log(res)
                let temp = res?.data?.filter((item) => item?.type == 3)
                setCities(temp)
            }).catch((err) => {
                console.error(err)
            })
    }
    const getProperties = () => {
        getPropertyApi()
            .unwrap()
            .then((res) => {
                console.log(res)
                setProperties(res?.data)
            }).catch((err) => {
                console.error(err)
            })
    }

    useEffect(() => {
        transactionList(
            pageno,
            fromdate,
            toDate,
            selectedPropertyId,
            // selectedCityId,
            search,
        );
        getLocations()
        getProperties()
    }, [pageno]);


    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Transaction ID",
                accessor: "transaction_id",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Property Name",
                accessor: "property",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row?.original?.property } })}>{value?.name}</p></div>
                },
            },
            {
                Header: "Owner Name",
                accessor: "owner",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner_id } })}>{value?.name}</p></div>
                },
            },
            {
                Header: "Type",
                accessor: "type",
                Cell: ({ value, row }) => {
                    return <p>{value == 1 ? "Room" : "Individual"}</p>;
                },
            },
            {
                Header: "Location",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row?.original?.property?.city?.name}</p>;
                },
            },
            {
                Header: "Subscribe Date",
                accessor: "transaction",
                Cell: ({ value, row }) => {
                    return <p>{moment(value?.subscription_start_date).format("DD-MM-YYYY")}</p>;
                },
            },
            {
                Header: "Expiry Date",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{moment(row?.original?.transaction?.end_date).format("DD-MM-YYYY")}</p>;
                },
            },

        ],
        []
    );

    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    MMC - Transaction List
                </h2>
            </div>
            <div className='d-flex ac-jb mt-3 gap-2'>
                <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">From Date</label>
                <div className='w-15'>
                    <DatePicker
                        type="date"
                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="From Date"
                        selected={fromdate}
                        onChange={(e) => {
                            transactionList(
                                1,
                                e,
                                toDate,
                                selectedPropertyId,
                                city,
                                search,
                            )
                        }}
                    />
                </div>
                <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">To Date</label>
                <div className='w-15'>
                    <DatePicker
                        type="date"
                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="To Date"
                        selected={toDate}
                        onChange={(e) => transactionList(
                            1,
                            fromdate,
                            e,
                            selectedPropertyId,
                            city,
                            search,

                        )}
                    />
                </div>
                <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">Property </label>
                <CustomSearchSelect
                    options={properties}
                    value={selectedPropertyId}
                    onChange={(propValue) => {
                        setSelectedPropertyId(propValue);
                        transactionList(
                            1,
                            fromdate,
                            toDate,
                            propValue,
                            city,
                            search,
                        );
                    }}
                    placeholder="Select Property"
                    width="200px"
                />
                {/* <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">City</label>
                    <CustomSearchSelect
                        options={cities}
                        value={selectedCityId}
                        onChange={(value) => {
                            setSelectedCityId(value);
                            transactionList(
                                1,
                                fromdate,
                                toDate,
                                selectedPropertyId,
                                value,
                                search,
                            );
                        }}
                        placeholder="Select City"
                        width="165px"
                    /> */}
                <div onChange={(e) => transactionList(1, fromdate, toDate, selectedPropertyId, e.target.value)} className='search-input'>
                    <input type='text' placeholder='Search' style={{ border: 'none', width: '100px' }} />
                    <img src={search_icon} className='search' />
                </div>
            </div>

            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />

        </div >
    );
};
export default TransactionList